<ng-container *ngIf="!isCreateNewCase"> </ng-container>

<div class="info">
  <div class="row" style="margin: 0">
    <div class="col-3 cases labelHead" *ngIf="!isCreateNewCase">
      <div class="row" *ngIf="allowDifferentUserCase">
        <div class="text-left-bold">Case History
        </div>
       <div class="user-container">
          <label class="user-label">
            <input 
            type="checkbox" 
            name="primarychk"
            [(ngModel)]="isParentChecked"
            (click)="loadPrimaryUser($event)"
            />
            <span>Primary User</span>
          </label>

          <label class="user-label">
            <input 
            name="childchk"
            type="checkbox" 
            [(ngModel)]="isChildChecked"
            (click)="loadChildUser($event)" />
            <span>Other User</span>
          </label>
       </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="">
            <div class="input-data">
              <label for="">Status</label>
              <select
                name="search-parameter"
                [(ngModel)]="statusValue"
                (ngModelChange)="searchCases($event)"
                id="search-parameter"
                style="background-color: #f8f9fb"
              >
                <option *ngFor="let search of status" [ngValue]="search" [selected]="statusValue?.type == search.type">
                  {{ search.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="">
            <div class="input-data">
              <label for="">Priority</label>
              <select
                name="search-parameter"
                [(ngModel)]="priorityValue"
                (ngModelChange)="searchCases($event)"
                id="search-parameter"
                style="background-color: #f8f9fb"
              >
                <option
                  *ngFor="let search of priority"
                  [ngValue]="search"
                  [selected]="priorityValue?.type == search.type"
                >
                  {{ search.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="search">
            <div class="container" style="width: 13.125rem">
              <input
                type="text"
                [(ngModel)]="searchValue"
                class=""
                style="width: 81.3%; border-bottom: none"
                placeholder=""
                (keydown.enter)="searchCases($event)"
              />
              <button class="search-btn" (click)="searchCases($event)">
                <img alt="" class="search-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          text-align: left;
          font-weight: bold;
          font-size: 0.688rem;
          line-height: 0.813rem;
          font-family: Gellix;
          letter-spacing: 0rem;
          color: #97999b;
          opacity: 1;
          padding-top: 1.25rem;
          /* padding-left: 0.625rem; */
          padding-bottom: 0.625rem;
        "
      >
        {{ cases.length > 0 ? 1 : 0 }} to {{ caseDataPerPage.length }} of {{ caseDataRes?.CaseCount.length }} matching
        cases
      </div>
      <!-- [ngClass]="step == 'step1' ? 'my_class1' : 'my_class2'" -->
      <div
        *ngFor="let date of cases"
        [ngClass]="[date.isSelected ? 'date-selected' : 'dates', date.hasError ? 'has-error' : 'no-error']"
        [ngStyle]="{'background-color': isDifferentUserCaseId(date.CaseID) == true || isDifferentUserCaseIdForTransfer(date.CaseID) == true ? '#a4f4f9' : ''}"
      >
        <span
          (click)="getCaseDetails(date.CaseID)"
          class="date-data"
          [ngStyle]="{
            'text-transform': date.AllowDelete ? 'uppercase' : 'none',
            'font-weight': date.AllowDelete || date.isDirty ? 'bold' : 'normal',
          }"
        >
          {{ date.Created | custdate }} <span *ngIf="date.CrmCaseID"> - {{ date.CrmCaseID }} </span> ({{ date.Status }}) </span

        >
        <span *ngIf="date.IsLocked">
          <img
            class="warning-icon-img"
            src="{{ baseHref }}/assets/images/icon-lock.svg"
            alt="Locked"
            title="Case Locked"
          />
        </span>
        <ng-container>
          <ng-container *ngIf="date.AllowDelete">
            <span (click)="deleteCase(date.CaseID)"><button style="background-color: transparent;" class="remove-btn-case">Remove</button> </span>
          </ng-container>
          <span class="icon-Container">
            <span class="date-dot"></span>

            <span class="warning-icon" *ngIf="date.AllowDelete" (mouseenter)="onMouseEnter(date.CaseID)"> ! </span>
          </span>
        </ng-container>

        <!-- <hr style="height: 0rem; margin: 0; border: none; border-top: 0.063rem solid #dfdfdf" /> -->
      </div>
      <!-- <div *ngFor="let date of cases" [ngClass]= "date.isSelected ? 'date-selected' : 'dates'" >
        <span (click)="caseSelected(date)"class="date-data">3/15/2024 12:58 PM (Open)</span>
        <span class="date-dot"></span>
        <hr style="height: 0rem;margin:0;
  border: none;
  border-top: 0.063rem solid #DFDFDF;">
  
  </div> -->
      <!-- <div class="flex-1"> -->
      <p-paginator
        (onPageChange)="onPageChange1($event)"
        [first]="first1"
        [rows]="rows1"
        [totalRecords]="caseDataRes?.CaseCount"
        [showJumpToPageDropdown]="false"
        [showFirstLastIcon]="false"
        [currentPage]="currentPage"
      >
      </p-paginator>
      <!-- </div> -->
    </div>
    <div
      [ngClass]="!isCreateNewCase ? 'col-9' : 'col-12'"
      style="padding: 0px 0px 0px 23px"
      [ngStyle]="{ 'padding-left': !isCreateNewCase ? '23px' : '0px' }"
    >
      <div class="row" *ngIf="!isCreateNewCase" style="margin-top: 10px">
        <div class="col-4">
          <div
            style="
              text-align: left;
              font-weight: bold;
              font-size: 0.938rem;
              line-height: 1.125rem;
              font-family: Gellix;
              letter-spacing: 0rem;
              color: #000048;
              opacity: 1;
              float: left;
            "
          >
            Case Details
          </div>
          <div
            *ngIf="this.selectedCaseId != null && this.selectedCaseId != 0"
            class="row container-fluid"
            style="height: 0.813rem; padding: 0"
          >
            <span
              style="
                text-align: left;
                font: normal normal 600 0.688rem/0.813rem Gellix;
                letter-spacing: 0rem;
                color: #53565a;
                opacity: 1;
                padding-top: 10px;
              "
              >Priority :
              <span
                style="
                  background: #cfefcc 0% 0% no-repeat padding-box;
                  border: 0.063rem solid #a7e6a1;
                  border-radius: 0.125rem;
                  display: inline-block;
                  opacity: 1;
                  padding: 3px 4px;
                "
                ><span
                  style="
                    text-align: left;
                    font: normal normal 600 0.625rem/0.75rem Gellix;
                    font-weight: 600;
                    font-size: 0.625rem;
                    line-height: 0.75rem;
                    font-family: Gellix, sans-serif;
                    letter-spacing: 0rem;
                    color: #26282b;
                    opacity: 1;
                  "
                  >{{ selectedCasePriority }}</span
                ></span
              ></span
            >
          </div>
        </div>
        <div class="col-8 text-end">
          <div style="margin: 0 30px 0px 0px">
                        <button
              *ngIf="this.selectedCaseId != null && this.selectedCaseId != 0 && showViewEmailButton"
              style="
                text-align: left;
                font-weight: 600;
                font-size: 0.688rem;
                line-height: 0.813rem;
                font-family: Gellix;
                letter-spacing: 0rem;
                color: #2e308e;
                padding: 0.3rem 0.8rem 0.3rem 0.8rem;
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 0.063rem solid #2e308e;
                border-radius: 0.875rem;
                opacity: 1;
                height: 1.5rem;
                margin-right: 0.313rem;
                margin-bottom: 0.35rem;
              "
              (click)="viewOriginalEmail()"
            >
              View Email
            </button>

            <button
              *ngIf="this.selectedCaseId != null && this.selectedCaseId != 0 && showViewAttachmentButton"
              style="
                text-align: left;
                font-weight: 600;
                font-size: 0.688rem;
                line-height: 0.813rem;
                font-family: Gellix;
                letter-spacing: 0rem;
                color: #2e308e;
                padding: 0.3rem 0.8rem 0.3rem 0.8rem;
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 0.063rem solid #2e308e;
                border-radius: 0.875rem;
                opacity: 1;
                height: 1.5rem;
                margin-right: 0.313rem;
                margin-bottom: 0.35rem;
              "
              (click)="viewAttachments()"
            >
              View Attachment(s)
            </button>
            <!-- <button
              *ngIf="queueType === 'Email' && this.selectedCaseId != null && this.selectedCaseId != 0"
              style="
                text-align: left;
                font-weight: 600;
                font-size: 0.688rem;
                line-height: 0.813rem;
                font-family: Gellix;
                letter-spacing: 0rem;
                color: #2e308e;
                padding: 0.3rem 0.8rem 0.3rem 0.8rem;
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 0.063rem solid #2e308e;
                border-radius: 0.875rem;
                opacity: 1;
                height: 1.5rem;
                margin-right: 0.313rem;
                margin-bottom: 0.35rem;
              "
              (click)="viewOriginalEmail()"
            >
              View Original Email
            </button> -->
            <button
              *ngIf="this.selectedCaseId != null && this.selectedCaseId != 0"
              style="
                text-align: left;
                font-weight: 600;
                font-size: 0.688rem;
                line-height: 0.813rem;
                font-family: Gellix;
                letter-spacing: 0rem;
                color: #2e308e;
                /* padding-top: 0.313rem; */
                padding: 0.3rem 0.8rem 0.3rem 0.8rem;
                /* padding-left: 0.8rem; */
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 0.063rem solid #2e308e;
                border-radius: 0.875rem;
                opacity: 1;
                /* width: 161px; */
                height: 1.5rem;
                /* float: right; */
                margin-right: 0.313rem;
                margin-bottom: 0.35rem;
              "
              (click)="caseChangeHistory()"
            >
              View Case Change History
            </button>
            <span *ngIf="allowDifferentUserCase && enableCaseCreation">
              <button
              class="btn-outline-gellix"
              [ngClass]="{ readonly: isUnsubmittedCase() == true }"
              id="create-case"
              (click)="createCaseForOtherUser($event)"
            >
              New Case For Other User
            </button>
            </span>
            <span *ngIf="((enableCaseCreation && !getIsCaseUserUnmapped()) || (enableCaseCreation && this.userId !='0') || (getIsUnknownContact() && enableCaseCreation && getIsAddNewUser() ) ) ">
            <button
              [ngClass]="{ readonly: isUnsubmittedCase() == true }"
              style="
                text-align: left;
                font-weight: 600;
                font-size: 0.688rem;
                line-height: 0.813rem;

                font-family: Gellix;
                letter-spacing: 0rem;
                color: #2e308e;

                opacity: 1;
                padding: 0.3rem 0.8rem 0.3rem 0.8rem;
                /* padding-left: 0.8rem; */
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 0.063rem solid #2e308e;
                border-radius: 0.875rem;
                opacity: 1;
                margin-bottom: 0.35rem;
                /* width: 161px; */
                height: 1.5rem;
                /* float: right; */
              "
              (click)="newCase()"
            >
              New Case
            </button>
            </span>
          </div>
          <div class="" [ngClass]="{ readonly: isReadOnlyCase() == true }" style="margin: 10px 0px 0px 0px">
            <button class="btn btn-danger show-err-btn" (click)="openModal()" *ngIf="errorSummary.length > 0">
              Invalid Fields ({{ errorSummary.length }})
            </button>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="cases.length > 0 || isCreateNewCase">
        <div [ngStyle]="{ 'margin-left': !isCreateNewCase ? '0rem' : '1.625rem', 'margin-top': '0.625rem' }">
          <form #dynamicForm="ngForm" *ngIf="conf?.Groups?.length > 0" [ngClass]="{ readonly: isReadOnlyCase() == true }">
            <div *ngFor="let group of conf.Groups" style="margin-bottom: 1rem">
              <div class="labelHead" *ngIf="group.GroupDescription != 'Test' && group.GroupDescription != 'CPTCode'">
                <div *ngIf="!showDifferentUserFields && childCaseUseDetails==null" style="margin: 0px 0px 7px 0">{{ group.GroupDescription }}</div>
                <div class="row">
                  <ng-container class="sec-1" *ngFor="let field of group.Fields; let first = first">
                    <ng-container
                      *ngIf="field.fieldType === 'Input' && field.Name !== 'PortalData' && field.Name !== 'ImageNetData' && !field.isEmail && !field.salesForceIntegrationRequired && field.show"
                    >
                      <!-- This details for other user create a case -->
                        <div 
                        style="margin: 0px 0px 7px 0;font-weight:bolder;"
                        *ngIf="showDifferentUserFields && first && childCaseUseDetails==null" >
                          OTHER USER DETAILS
                        </div>
                        <div class="col-6 mb-5p input-data" *ngIf="showDifferentUserFields && first">
                          <label>User Type:</label>
                          <input class="text-value" type="text" [value]="differentUserData?.role" readonly/>
                        </div>
                        <div class="col-6 mb-5p input-data" *ngIf="showDifferentUserFields && first">
                          <label>Full Name:</label>
                          <input class="text-value" type="text" [value]="differentUserData?.fullName" readonly/>
                        </div>
                        <div class="col-6 mb-5p input-data" *ngIf="showDifferentUserFields && first">
                          <label>Record ID:</label>
                          <input class="text-value" type="text" [value]="differentUserData?.recordID" readonly/>
                        </div>
                        <div class="col-6 mb-5p input-data" *ngIf="showDifferentUserFields && first">
                          <label>QNXT ID:</label>
                          <input class="text-value" type="text" [value]="differentUserData?.qnxtID" readonly />
                        </div>
                        
                        <!-- This details for primary user which is created for other user case -->
                        <div *ngIf="childCaseUseDetails!=null && first" style="margin: 0px 0px 7px 0;font-weight:bolder;">CASE ORIGINATOR DETAILS</div>
                        <div class="col-6 mb-5p input-data" *ngIf="childCaseUseDetails!=null && first">
                          <label>User Type:</label>
                          <input class="text-value" type="text" [value]="childCaseUseDetails?.Role" readonly/>
                        </div>
                        <div class="col-6 mb-5p input-data" *ngIf="childCaseUseDetails!=null && first">
                          <label>Full Name:</label>
                          <input class="text-value" type="text" [value]="childCaseUseDetails?.FullName" readonly/>
                        </div>
                        <div class="col-6 mb-5p input-data" *ngIf="childCaseUseDetails!=null && first">
                          <label>Record ID:</label>
                          <input class="text-value" type="text" [value]="childCaseUseDetails?.ShortVanityID" readonly/>
                        </div>
                        <div class="col-6 mb-5p input-data" *ngIf="childCaseUseDetails!=null && first">
                          <label>QNXT ID:</label>
                          <input class="text-value" type="text" [value]="childCaseUseDetails?.CrmUserID" readonly />
                        </div>
                      
                      <!-- This details for case informations -->
                      <div *ngIf="(showDifferentUserFields || childCaseUseDetails!=null) && first" style="margin: 10px 0px 7px 0;font-weight:bolder;">{{ group.GroupDescription }}</div>
                      <div class="col-6 mb-5p input-data">
                        <label for="{{ field.Name }}"
                          >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label
                        >
                        <!-- <input (input)="onFormDataChange(group, field, $event, null)" class="text-value" type="text"
                          id="{{ field.fieldID }}" [value]="getModel(group, field)" [disabled]="field.isDisabled" /> -->

                        <input
                          (input)="onFormDataChange(group, field, $event, null)"
                          class="text-value"
                          type="text"
                          id="{{ field.fieldID }}"
                          [value]="
                            field.Name === 'Opened' && field.Label === 'Opened'
                              ? getCurrentDateTime(getBackendDate(field))
                              : getModel(group, field)
                          "
                          [disabled]="field.isDisabled"
                        />
                        <div
                          [ngStyle]="{ width: !isCreateNewCase ? '24.44%' : '46.38%' }"
                          class="underline-fixed"
                        ></div>
                        <div class="text-danger" *ngIf="field.invalid">
                          <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                          <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                          <small *ngIf="field.minLengthError">
                            {{ field.Label }} must be at least {{ field.minLength }} characters
                          </small>
                          <small *ngIf="field.maxLengthError">
                            {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                          >
                        </div>
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="field.fieldType === 'DropDown' && field.Name !== 'EscalationType' && field.show"
                    >
                      <div class="col-6 mb-5p input-data">
                        <div class="input-data">
                          <label for="{{ field.Name }}"
                            >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label
                          >
                          <select
                            [ngModel]="getModel(group, field)"
                            name="{{ field.Name }}"
                            id="{{ field.fieldID }}"
                            (change)="onDropDownChange(group, field, $event, null)"
                            [disabled]="field.isDisabled"
                          >
                            <option value="">Select One</option>
                            <option
                              *ngFor="let option of field.fieldOptions | orderBy: 'DisplayOrder'"
                              value="{{ option.Value }}"
                            >
                              {{ option.Name }}
                            </option>
                          </select>
                          <div
                            [ngStyle]="{ width: !isCreateNewCase ? '24.44%' : '46.38%' }"
                            class="underline-fixed"
                          ></div>
                        </div>
                        <div class="text-danger" *ngIf="field.invalid">
                          <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                          <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                          <small *ngIf="field.minLengthError">
                            {{ field.Label }} must be at least {{ field.minLength }} characters
                          </small>
                          <small *ngIf="field.maxLengthError">
                            {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                          >
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="field.fieldType === 'CheckBox' && !field.isEmail && field.show">
                      <div class="col-12 mb-5p input-data">
                        <div class="form-check">
                          <input
                            class="form-check-input checkbox"
                            type="checkbox"
                            [value]="getModel(group, field)"
                            [disabled]="field.isDisabled"
                            (change)="onCheckBoxChange(group, field, $event)"
                            [checked]="field.isSelected"
                            [id]="field.fieldID"
                          />
                          <label class="checkbox-label form-check-label-1" for="{{ field.fieldID }}">
                            {{ field.Label }}
                          </label>
                        </div>
                        <!-- <div class="underline-fixed"></div> -->
                        <div class="text-danger" *ngIf="field.invalid">
                          <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                          <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                          <small *ngIf="field.minLengthError">
                            {{ field.Label }} must be at least {{ field.minLength }} characters
                          </small>
                          <small *ngIf="field.maxLengthError">
                            {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                          >
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="field.fieldType === 'CaseAssigner'">
                      <app-case-assigner
                        [group]="group"
                        (caseAssignerValue)="updateCaseAssigner($event)"
                        [caseID]="selectedCaseId"
                        [field]="field"
                        [caseStatusID]="caseStatusID"
                        [caseAssignerInput]="this.caseAssignerValue"
                        [hidden]="field.show"
                        [QueueName]="this.QueueName"
                        [AgentName]="this.AgentName"
                      ></app-case-assigner>
                    </ng-container>
                    <ng-container *ngIf="field.fieldType === 'CaseUserPicker' && field.show">
                      <div class="col-6 mb-5p input-data">
                        <div class="input-data">
                          <label for="{{ field.Name }}"
                            >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label
                          >
                          <div class="input-group" [ngStyle]="{ height: !isCreateNewCase ? '19px' : '23px' }">
                            <input
                              style="border: none; padding: 2px"
                              [value]="getModel(group, field)"
                              class="form-control text-value"
                              type="text"
                              id="{{ field.fieldID }}"
                              (input)="onFormDataChange(group, field, $event, null)"
                              [disabled]="true"
                              [title]="getModel(group, field)"
                            />
                            <button class="remove-btn" (click)="removeMember(field)">Remove</button>
                            <button class="find-btn" (click)="findMember(field)">
                              <img alt="" class="find-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
                            </button>
                          </div>
                          <!-- <div>
                          <input
                            [value]="getModel(group, field)"
                            class="text-value"
                            type="text"
                            id="{{ field.fieldID }}"
                            (input)="onFormDataChange(group, field, $event, null)"
                           
                            [disabled]="true"
                          />
                          <button class="remove-btn" (click)="removeMember()">
                            Remove
                          </button>
                          <button class="find-btn" (click)="findMember()">
                            <img alt="" class="find-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
                          </button>
                        </div> -->
                          <!-- <select
                          [formControlName]="field.Name"
                          name="{{ field.Name }}"
                          id="{{ field.fieldID }}"
                          style="width: 10rem"
                        >
                          <option
                            *ngFor="let option of field.fieldOptions | orderBy: 'DisplayOrder'"
                            value="{{ option.Value }}"
                          >
                            {{ option.Name }}
                          </option>
                        </select> -->
                          <div
                            [ngStyle]="{ width: !isCreateNewCase ? '24.44%' : '46.38%' }"
                            class="underline-fixed"
                          ></div>
                        </div>
                        <div class="text-danger" *ngIf="field.invalid">
                          <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                          <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                          <small *ngIf="field.minLengthError">
                            {{ field.Label }} must be at least {{ field.minLength }} characters
                          </small>
                          <small *ngIf="field.maxLengthError">
                            {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                          >
                        </div>
                      </div>
                    </ng-container>

                    <ng-container
                      *ngIf="(field.fieldType === 'DateTimePicker') && field.show">
                      <div class="col-6 mb-5p input-data">
                        <label for="{{ field.Name }}"
                          >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label
                        >
                        <!-- Custom Datepicker With Timezone -->
                        <app-calendar-with-timezone
                          [defaultDate]="field.value"
                          [showTime] = "true"
                          [hourFormat]= "12"
                          [displayTimeZone] = "true"
                          [parentWidth] = "'295px'"
                          [disabled]="field.isDisabled"
                          (dateSelected)="onCalendarDateSelected(group, field, $event)"
                        ></app-calendar-with-timezone> 
                        
                        <div
                          [ngStyle]="{ width: !isCreateNewCase ? '24.44%' : '46.38%' }"
                          class="underline-fixed"
                        ></div>
                        <div class="text-danger" *ngIf="field.invalid">
                          <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                          <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                          <small *ngIf="field.minLengthError">
                            {{ field.Label }} must be at least {{ field.minLength }} characters
                          </small>
                          <small *ngIf="field.maxLengthError">
                            {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                          >
                        </div>
                      </div>
                    </ng-container>
                    <ng-container
                    *ngIf="(field.fieldType === 'DatePicker') && field.show" >
                    <div class="col-6 mb-5p input-data">
                      <label for="{{ field.Name }}"
                        >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label
                      >
                      <input
                        type="date"
                        name="followUp"
                        class="datetimepicker"
                        [ngModel]="field.value | date: 'yyyy-MM-dd'"
                        (ngModelChange)="field.value = $event"
                        (change)="onFormDataChange(group, field, $event, null)"
                        [value]="getModel(group, field)"
                        [ngModelOptions]="{ standalone: true }"
                        autocomplete="off"
                        [disabled]="field.isDisabled"
                      />                     
                      <div
                        [ngStyle]="{ width: !isCreateNewCase ? '24.44%' : '46.38%' }"
                        class="underline-fixed"
                      ></div>
                      <div class="text-danger" *ngIf="field.invalid">
                        <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                        <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                        <small *ngIf="field.minLengthError">
                          {{ field.Label }} must be at least {{ field.minLength }} characters
                        </small>
                        <small *ngIf="field.maxLengthError">
                          {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                        >
                      </div>
                    </div>
                  </ng-container>
                    <ng-container *ngIf="field.fieldType === 'FilePicker' && field.show">
                      <div class="col-12 mb-5p input-data">
                        <div class="row">
                          <div class="col-12">
                            <label for="{{ field.Name }}"
                              ><span class="doc-label">
                                {{ field.Label }} <span class="doc-count">({{ field.value.length }} files)</span> </span
                              ><span class="star" *ngIf="field.isRequired"> *</span>
                              <button class="submitbtn action-btn1 add-btn" (click)="addNewFile()">Add New</button>
                            </label>
                            <label class="doc-hint" *ngIf="field.value.length == 0">No Attachments</label>
                            <label
                              class="doc-hint file-name"
                              title="{{ field?.uploadedFile.Name }}"
                              *ngIf="field.value.length > 0 && field.uploadedFile"
                            >
                              {{
                                field?.uploadedFile.Name.length > 60
                                  ? field?.uploadedFile.Name.substring(0, 45) + '...'
                                  : field?.uploadedFile.Name
                              }}
                              <span class="delete-file" (click)="deleteFile(field, field.uploadedFile)">X</span>
                            </label>
                          </div>
                          <!-- <div class="col-6" style="margin-top: 0.75rem">
                          </div> -->

                          <!--File Details-->
                          <ng-container *ngIf="field.fileDetails">
                            <div
                              style="padding: 12px 23px; border-top: 2px solid #ccc; /* margin-left: 11px; */"
                              *ngFor="let item of field.fileDetails"
                            >
                              <div class="row">
                                <div class="col-6 no-padding">
                                  <label class="doc-hint file-name" title="{{ item.Name }}">
                                    {{ item.Name.length > 60 ? item.Name.substring(0, 45) + '...' : item.Name }}
                                    <!-- {{item.Name}} -->
                                    <span class="delete-file" (click)="deleteFile(field, item)">X</span>
                                  </label>
                                </div>
                                <div class="col-4 no-padding" style="width: 36%; margin-top: 1rem">
                                  <!-- <button
                                    style="float: right; margin-right: 1rem"
                                    class="btn action-btn1"
                                    (click)="item.showFileDetails = !item.showFileDetails"
                                  >
                                    <span *ngIf="!item.fileData">Loading...</span>
                                    <span *ngIf="item.fileData">Preview and Details</span>
                                  </button> -->
                                  <button
                                  style="float: right; margin-right: 1rem"
                                  class="btn action-btn1"
                                  (click)="onPreview(item)"> Preview and Details </button>
                                  
                                </div>
                                <div class="col-2 no-padding" style="width: 14%; margin-top: 1rem">
                                  <button class="btn action-btn1" (click)="downloadBase64File(item)">Download</button>
                                </div>
                              </div>

                              <div
                                class="row crud-container"
                                style="margin-top: 0.5rem"
                                *ngIf="item.showFileDetails && item.fileData"
                              >
                                <div class="file-details-tabs">
                                  <nav class="navbar navbar-expand-lg">
                                    <ul class="navbar-nav">
                                      <!--Preview-->
                                      <li
                                      *ngIf="item?.fileData?.MimeType.includes('application/pdf') ||
                                      item?.fileData?.MimeType.includes('image/')"
                                        class="nav-item"
                                        [ngClass]="{ active: fileDetailsTabs[0].isSelected }"
                                        (click)="fileDetailsTabClick(fileDetailsTabs[0])"
                                      >
                                        <a class="nav-link">{{ fileDetailsTabs[0].label }}</a>
                                      </li>
                                      <!--Details-->
                                      <li
                                        class="nav-item"
                                        [ngClass]="{
                                          active:
                                            fileDetailsTabs[1].isSelected }"
                                        (click)="fileDetailsTabClick(fileDetailsTabs[1])"
                                      >
                                        <a class="nav-link">{{ fileDetailsTabs[1].label }}</a>
                                      </li>
                                    </ul>
                                  </nav>
                                </div>

                                <div *ngIf="activeFileDetailsTab === 1 && (item.fileData.MimeType.includes('image/') || item.fileData.MimeType.includes('application/pdf'))">
                                  <!-- <label *ngIf="!item.fileData.MimeType.includes('image/')">No preview available.</label> -->
                                  <div class="col" *ngIf="item.fileData.MimeType.includes('image/')" style="border: 2px solid #b7b7b7;text-align: center;">
                                    <img class="img-fluid" [src]="item.fileData.base64" width="275" style="max-width:100%;max-height:400px" />
                                  </div>
                                  <div class="col" *ngIf="item.fileData.MimeType.includes('application/pdf')">
                                    <iframe [src]="item.fileData.base64" width="100%" height="400" style="border:none;"></iframe>
                                  </div>
                                </div>
                                <div *ngIf="(activeFileDetailsTab === 2 && (item.fileData.MimeType.includes('application/pdf') || item.fileData.MimeType.includes('image/')))
                                || (!item.fileData.MimeType.includes('application/pdf') && !item.fileData.MimeType.includes('image/'))">
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td style="width: 25%">ID</td>
                                        <td>{{ item.FileID }}</td>
                                      </tr>
                                      <tr>
                                        <td>Name</td>
                                        <td>{{ item.Name }}</td>
                                      </tr>
                                      <tr>
                                        <td>Description</td>
                                        <td>{{ item.Description }}</td>
                                      </tr>
                                      <tr>
                                        <td>Size</td>
                                        <td>{{ formatBytes(item.Size) }}</td>
                                      </tr>
                                      <tr>
                                        <td>URL</td>
                                        <td>
                                          <!-- <a href="{{ appBaseUrl + item.URL }}">{{ item.URL }}</a> -->
                                          <span style="cursor: pointer; color: #0a58ca" (click)="downloadBase64File(item)">{{
                                            item.Name
                                          }}</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Disabled</td>
                                        <td>{{ item.Disabled }}</td>
                                      </tr>
                                      <tr>
                                        <td>Created</td>
                                        <td>{{ item.Created | custdate }}</td>
                                      </tr>
                                      <tr>
                                        <td>Last Updated</td>
                                        <td>{{ item.LastUpdated | custdate }}</td>
                                      </tr>
                                      <tr>
                                        <td>File Type</td>
                                        <td>{{ item.FileType.Name }}</td>
                                      </tr>
                                      <tr>
                                        <td>Creator</td>
                                        <td>{{ item.Creator.FirstName }} {{ item.Creator.LastName }}</td>
                                      </tr>
                                      <tr>
                                        <td>Updater</td>
                                        <td>{{ item.Updater.FirstName }} {{ item.Updater.LastName }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>

                        <div class="row" *ngIf="showAddNewFile" style="margin-top: 1rem">
                          <app-file-uploader
                            title=""
                            (handleCancel)="handleCancel($event)"
                            (handleFileUpload)="handleFileUpload(group, field, $event)"
                            [allowedFileTypes]="allowedFilesTypes"
                            [maxFileSize]="maxFileSize"
                          ></app-file-uploader>
                        </div>
                      </div>
                    </ng-container>
                    <!-- portal data start-->
                    <ng-container *ngIf="field.Name === 'PortalData' && field.show">
                      <label class="doc-hint" *ngIf="field.value == ''">No data available</label>
                      <div *ngIf="field.value != ''" class="col-12 mb-5p portal-field">
                        <!-- <div class="row" style="padding: 6px;"> -->
                        <div class="portal-data" *ngFor="let item of portalDataArray">
                          <label for="{{ field.Name }}">{{ item.label }} </label>
                          <!-- <input type="text" [value]="item.value"  /> -->
                          <span class="portal-value">{{ item.value }}</span>
                        </div>

                        <!-- </div> -->
                      </div>
                    </ng-container>
                    <!-- portal data end -->

                    <ng-container *ngIf="field.fieldType === 'Hidden'">
                      <input
                        class="hidden"
                        type="hidden"
                        [id]="field.fieldID"
                        [name]="field.Name"
                        [value]="getModel(group, field)"
                      />
                    </ng-container>
                    <ng-container *ngIf="field.fieldType === 'Input' && field.salesForceIntegrationRequired && field.show">
                      <button
                      class="sales-force-btn"
                      (click)="handleSalesForceintegration()">
                     {{field.Label}}
                    </button>
                    </ng-container>
                  </ng-container>
                  <ng-container class="sec-2" *ngFor="let field of group.Fields">
                    <ng-container>
                      <div
                        class="col-12 mb-5p input-data"
                        *ngIf="field.fieldType === 'TextArea' && !field.isEmail && field.show"
                      >
                        <div style="margin-top: 5px">
                          <label for="{{ field.Name }}"
                            >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span>
                            <button
                              class="notes-btn allow-click"
                              *ngIf="
                                field.Name === 'Notes' &&
                                field.isNoteHistoryEnabled == true &&
                                !field.isEmail &&
                                field.show
                              "
                              (click)="openNodesHistoryModel()"
                            >
                              Notes History
                            </button>
                            <button
                            class="notes-btn"
                            *ngIf="
                              field.Name === 'Notes' &&
                              field.isNoteHistoryEnabled == true &&
                              !field.isEmail &&
                              field.show && enableTemplateButton && enableAICaseNotesTemplate
                            "
                            (click)="openTemplateModel()"
                            [disabled]="disableTemplateButton"
                          >
                            Template
                          </button>
                            </label
                          >

                          <textarea
                            class="form-control txtarea"
                            id="{{ field.fieldID }}"
                            [value]="getModelText(group, field)"
                            [innerHTML]="getModelText(group, field)"
                            (input)="onFormDataChange(group, field, $event, null)"
                            placeholder=""
                            [disabled]="field.isDisabled"
                          ></textarea>

                          <!-- <div class="underline-fixed"></div> -->

                          <div class="text-danger" *ngIf="field.invalid">
                            <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                            <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                            <small *ngIf="field.minLengthError">
                              {{ field.Label }} must be at least {{ field.minLength }} characters
                            </small>
                            <small *ngIf="field.maxLengthError">
                              {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                            >
                          </div>
                        </div>
                        <!-- notes -->

                        <!-- <div [ngStyle]="{ display: display }">
                      <div class="modal" [ngStyle]="{ display: display }">
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content" style="width: 290px; height: 301px">
                            <div class="modal-header menu" style="border-radius: 0">
                              <span class="menu-heading"> Notes History</span>
                              <span class="close" (click)="onCloseHandled()">X</span>
                            </div>
                            <div class="modal-body">
                              <div 
                                class="a5View CLView CLHTMLView UIHTMLControl UITextField"
                                id="804738163"
                                data-a5id="NotesHistoryPopUp"
                                style="
                                  overflow: hidden;
                                  display: block;
                                  background-color: transparent;
                                  position: absolute;
                                  zoom: 1;
                                  font-family: Roboto;
                                  width: 590px;
                                  height: auto;
                                  min-height: 1em;
                                  z-index: 0;
                                  left: 5px;
                                  top: 5px;
                                  padding: 0px;
                                " *ngFor="let notesData of notesHistory"
                              >
                              <span class="Noteshistory">{{notesData?.fieldid}},{{notesData?.caseid}},{{notesData?.oldvalue}}</span><br /><span
                              class="NotesPre"
                              >{{notesData?.newvalue}} </span
                            ><br />
                              
                              </div>
                             
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> -->
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container class="sec-3" *ngFor="let field of group.Fields">
                    <ng-container
                      *ngIf="field.fieldType === 'DropDown' && field.Name === 'EscalationType' && field.show"
                    >
                      <div class="input-data col-6">
                        <div class="input-data">
                          <label for="{{ field.Name }}"
                            >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label
                          >
                          <select
                            [ngModel]="getModel(group, field)"
                            name="{{ field.Name }}"
                            id="{{ field.fieldID }}"
                            (change)="onDropDownChange(group, field, $event, null)"
                          >
                            <option value="">Select One</option>
                            <option
                              *ngFor="let option of field.fieldOptions | orderBy: 'DisplayOrder'"
                              value="{{ option.Value }}"
                            >
                              {{ option.Name }}
                            </option>
                          </select>
                          <div
                            [ngStyle]="{ width: !isCreateNewCase ? '24.44%' : '46.38%' }"
                            class="underline-fixed"
                          ></div>
                        </div>
                        <div class="text-danger" *ngIf="field.invalid">
                          <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                          <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                          <small *ngIf="field.minLengthError">
                            {{ field.Label }} must be at least {{ field.minLength }} characters
                          </small>
                          <small *ngIf="field.maxLengthError">
                            {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                          >
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <!-- <ng-container class="sec-4" *ngFor="let field of group.Fields">
                   
                  </ng-container> -->
                </div>
              </div>
            </div>

            <!-- Image Net Data Start-->
            <div *ngFor="let group of conf.Groups" style="margin-bottom: 1rem">
	            <div class="row">
                <ng-container class="sec-1" *ngFor="let field of group.Fields">
				          <ng-container *ngIf="field.Name === 'ImageNetData' && field.show">
                      <div class="labelHead">
                        <div style="margin: 0px 0px 7px 0">Image Net Data</div>
                      </div>
                      <label class="doc-hint" *ngIf="field.value == ''">No data available</label>
                      <div *ngIf="field.value != ''" class="col-12 mb-5p portal-field">
                        <div class="portal-data" *ngFor="let item of imageNetDataArray">
                          <ng-container *ngIf="item.value">
                            <label for="{{ field.Name }}">{{ item.label === 'ImageNetURL' ? 'Open DCN' : item.label }} </label>
                            <span class="portal-value">
                              <a *ngIf="item.label === 'ImageNetURL'" [href]="item.value" target="_blank" rel="noopener noreferrer">Open</a>
                              <ng-container *ngIf="item.label !== 'ImageNetURL'">{{ item.value }}</ng-container>
                            </span>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
			            </ng-container>
              </div>
            </div>
            <!-- Image Net Data End-->

            <!--Test & CPT code -->
            <!-- <div *ngFor="let group of conf.Groups" style="margin-bottom: 1rem">
              <div class="labelHead" *ngIf="group.GroupDescription == 'Test'">
                <div style="margin: 0px 0px 7px 0">{{ group.GroupDescription }}</div>
                <div class="row">
                    <app-test-cpt (removeCptCode)="removeCptCode($event)" (updateData)="updateData($event)" [data]="testCpt"></app-test-cpt>
                </div>
              </div> 
            </div>  
            -->
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="cd-modal" *ngIf="!isCreateNewCase">
    <div class="modal" [ngStyle]="{ display: display }">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header menu" style="border-radius: 0">
            <span class="menu-heading"> Cases - Invalid Fields </span>
            <span class="close" (click)="onCloseHandled()">X</span>
          </div>
          <div class="modal-body">
            <ul>
              <li *ngFor="let item of errorSummary">({{ item.caseId }}) {{ item.fieldName }} is invalid.</li>
            </ul>
          </div>
          <div class="modal-footer" style="justify-content: center">
            <button type="button" [ngClass]="'done-btn-active'" (click)="onCloseHandled()">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-chatbot *ngIf="enableKBChatbot"></app-chatbot>
